import { render, staticRenderFns } from "./SquareCardForm.vue?vue&type=template&id=32445246&"
import script from "./SquareCardForm.vue?vue&type=script&lang=js&"
export * from "./SquareCardForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports